function trackFB(value, currency, id, type, name){
  /*
  
  let value1 = parseFloat(value).toFixed(2);

  fbq('track', 'AddToCart', {
    value: value1,
    currency: currency,
    content_ids: id,
    content_type: 'product_group',
    content_name: name,
    content_category: type,
    
  });
    */
}

function ViewContent(value, currency, id, type, name){
  /*
  let value1 = parseFloat(value).toFixed(2);
  

  fbq('track', 'ViewContent', {
    value: value1,
    currency: currency,
    content_ids: id,
    content_type: 'product_group',
    content_name: name,
    content_category: type,
    
  });
    */
}

function initiateCheckout(value, currency, ids, items){
  /*

 const formatted = ids;
  const formattedItems = items.replace('&amp;', '').replace("'","").split(',');

   if(false == !!sessionStorage.getItem('first_sub')) { 
            
     
     
       let number = parseFloat(value.split(',').join(''));
        let price = number.toFixed(2);                                
	                     
    fbq('track', 'InitiateCheckout', {

      value: price,
      currency: currency,
      content_ids: formatted,
      content_name: formattedItems,
       content_type: 'product_group'
    });


   sessionStorage.setItem('first_sub', true); 
                                                 
 }
    */ 
  
  
  
  
  
  
  
}
 


/*$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top + 30;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function() {
    if ($('#shopify-section-product-recommendations').isInViewport()) {
      $('.button_wrapper').css("position","relative");
        $('.ProductMeta__Description').append($('.button_wrapper'));
    } else {
       $('.button_wrapper').css("position","fixed");
    }
});*/

function resizeGallery(){

  var x = $('.Product__Slideshow img').height();
  $('.Product__Slideshow').css("height", x);

}


function hideMenu(){





  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('#shopify-section-header').outerHeight();

  $(window).scroll(function(event){
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
      return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
      // Scroll Down
      $('#shopify-section-header').removeClass('nav-down').addClass('nav-up');
    } else {
      // Scroll Up
      if(st + $(window).height() < $(document).height()) {
        $('#shopify-section-header').removeClass('nav-up').addClass('nav-down');
      }
    }

    lastScrollTop = st;
  }


}


$(function() {
  
  var list = $('.js-dropdown-list');
  var link = $('.js-link');
  link.click(function(e) {
    e.preventDefault();
    list.slideToggle(200);
  });
  list.find('a').click(function() {
    var text = $(this).html();
    var icon = '<i class="fa fa-chevron-down"></i>';
    link.html(text+icon);
    list.slideToggle(200);
    if (text === '* Reset') {
      link.html('Select one option'+icon);
    }
  });

  //$('a[data-action="toggle-search"]').click(function(event) {
    //console.log('clicked')
  //});

  $(document).on('click', '.PageOverlay.is-visible', function () {
      // your function here
    //console.log("click on overlay")
    //$('#desksearch').trigger("click");
    document.getElementById('desksearch').click();
    //$('html').removeClass("no-scroll")
    //$(this).removeClass("is-visible");
    //$("#Search").attr("aria-hidden","true");
    //console.log('clicked')
  });
  
  
  
  
});

function toggleHeight(){
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;



  if($('#section-announcement').length && isMobile && $(window).scrollTop() == 0){
    const fromTop = $('#section-announcement').height();
    $("#sidebar-menu").css("top",fromTop);
  }else if(isMobile){
    $("#sidebar-menu").css("top",0);
  }

}

function hoverMenu(){

  $( ".Linklist__Item" ).hover(

    function() {

      const id = $(this).attr('id');
      $('#'+id+'_open' ).attr( "aria-hidden", 'false' );
    }, function() {

      const id = $(this).attr('id');
      $('#'+id+'_open' ).attr( "aria-hidden", 'true' );
    }
  );

  $( ".second_menu" ).hover(

    function() {

      const id = $(this).attr('id');

      $('#'+id).attr( "aria-hidden", 'false' );
    }, function() {

      const id = $(this).attr('id');
      $('#'+id).attr( "aria-hidden", 'true' );
    }
  );

}


function toggleMobileMenu(){

  $( "#menu_op" ).on( "click", function() {

    $('.PageOverlay').css('opacity','0');
  });
  $( ".Menu__Button" ).on( "click", function() {
    const id = $(this).attr('id');
    const aria = $(this).attr('aria-expanded');
    if(aria != 'true'){
      if (id == 'MEN'){





        $('.Drawer__Content').removeClass('black');
        $('.Drawer__Content').removeClass('saffron--bg');
        $('.Menu__Button').removeClass('grey');
        $('.Drawer__Content').addClass('cadet_blue--bg');
        $('.Drawer__Content').addClass('white');
        $(this).addClass('white');
        $('#WOMEN').addClass('grey');
        $('.CurrencySelector__Select').removeClass('black').addClass('white');    
        $('.Select--transparent svg').removeClass('black').addClass('white'); 






      }else{





        $('.Drawer__Content').removeClass('cadet_blue--bg');
        $('.Drawer__Content').removeClass('white');
        $('.Drawer__Content').addClass('black');
        $('.Drawer__Content').addClass('saffron--bg');
        $(this).removeClass('grey'); 
        $('#MEN').removeClass('white');
        $('#MEN').addClass('grey');
        $('.CurrencySelector__Select').removeClass('white').addClass('black');
        $('.Select--transparent svg').removeClass('white').addClass('black'); 





      }

      $( ".Collapsible" ).each(function() {

        $( this ).toggle();
      });

      $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
    }
  });


}


function toggleStores(){

  $( ".link-stores" ).on( "click", function() {
    var id = $(this).attr('id');

    if(id=="ALL"){

      $( ".stores_wrapper" ).each(function() {
        $( this ).addClass( "open-stores" );
      });
    }else{
      $( ".stores_wrapper" ).not(this).each(function() {
        $( this ).removeClass( "open-stores" );
      });
      $(".stores--wrapper").find('#'+id).toggleClass('open-stores').siblings().removeClass('open-stores');

    }

    $(this).addClass('light_grey').siblings().removeClass('light_grey');
  });
  //mobile
  $('.mobile--stores').on( "click", function() {
    $( ".mobile--stores" ).each(function() {
      $(this).toggleClass('border--no');
    });


    $(this).siblings().slideToggle();



  });






}


function resizeVideo(){
  const width = $(window).width();
  const height = $(window).height();

  const containerHeight = $("#section-slideshow").height();
  const containerWidth = $("#section-slideshow").width();

  const el = $("#Slideshow__DynamicVideo");
  if(!el.length) return;

  const videoWidth = el.width();

  el.css('transform', `translateX(0px)`);

  el.attr('width', 'auto');
  el.attr('height', '100%');


  if(containerWidth > videoWidth){
    el.attr('height', 'auto');
    el.attr('width', containerWidth);
  }
  else{
    const containerCenterX = videoWidth/2 - containerWidth/2;
    el.css('transform', `translateX(${-containerCenterX}px)`);


  }


}
function generateInstagramTemplate(url, likes, caption, date){
  return `<div class="Instafeed__Cell">` + `<div class="Instafeed__Image Image--lazyLoad Image--zoomOut" data-expand="10" data-bg="${url}" aria-label="Open on Instagram"></div>` + '<div class="Instafeed__Overlay">' + `<p class="Instafeed__Caption">${caption}</p>` + `<time class="Instafeed__Date Heading u-h6">${date}</time>` + '</div>' + '</div>';
}

function storeConfig(key, dataObj){

  const data = {
    asset: {
      key: `config/${key}`,
      attachment: JSON.stringify(dataObj)
    }
  }

  const stringifiedData = JSON.stringify(data);


  return new Promise((resolve, reject) => {
    $.ajax({ 
      url: `/admin/api/2021-01/themes/${Shopify.theme.id}/assets.json`,
      type: 'PUT',
      data: stringifiedData,
      beforeSend: function(request) {
        request.setRequestHeader("Access-Control-Allow-Origin", "*");
        request.setRequestHeader("Content-Type", "application/json");
      },
      success: function(response) {
        resolve(response);
      },
      error: function(er){
        reject(er);
      }
    })
  });
}

function getAsset(key){

  return new Promise((resolve, reject) => {

    $.ajax({ 
      url: `/admin/api/2021-01/themes/${Shopify.theme.id}/assets.json?asset[key]=${key}`,
      type: 'GET',
      crossDomain: true,
      beforeSend: function(request) {
        request.setRequestHeader("Access-Control-Allow-Origin", "www.nikben.com/");
      },
      success: function(response) {
        resolve(response);
      },
      error: function(er){
        reject(er);
      }
    });
  });
}

async function fetchIGFeed(){

  $.ajax({
    url: `https://insta-feed-bucket.s3.eu-central-1.amazonaws.com/nikbenfeed.json`, // or /users/self/media/recent for Sandbox
    type: 'GET',
    beforeSend: function(request) {
      request.setRequestHeader("Access-Control-Allow-Origin", "*");
    },
    success: function(response) {
      const media = response.data;

      $('#media').append(media.length + '<p class=\'ig\'> posts </p>');

      const images = media.map(node => {
        const url = node['media_url'];
        const time = node['timestamp'];
        const caption = node['caption']
        return generateInstagramTemplate(url, null, caption, '' );
      });

      var prepend_image = images.slice(0, 1);
      var append_image = images.slice(1 , 4);  
      var rest_images = images.slice(4, 10);

      $('.Instafeed #Row1').prepend(prepend_image);
      $('.Instafeed #Row1').append(append_image);
      $('.Instafeed #Row2').append(rest_images);

    }
  });
}

function appendAdd(){
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;


  if(isMobile) {
    $('.Product__InfoWrapper').append($('.button_wrapper'));

  }
}

$( window ).scroll(function() { 

  toggleHeight();
});

$( document ).ready(function() { 
  toggleHeight();
  hideMenu();
  appendAdd();
  hoverMenu();
  fetchIGFeed();
  resizeVideo();
  toggleStores();
  toggleMobileMenu();
  resizeGallery();
});




/*  
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;


    if(!isMobile) {
$(window).scroll(function() {
$(window).scroll(function () {
    if ($(this).scrollTop()  <= 0 ){
      $(".AnnouncementBar").slideDown(800);
     $(".Header__LogoLink").slideDown(500);
        $(".Header__FlexItem").removeClass("Open");


    }else{
  $(".Header__LogoLink").slideUp(500);

  $(".Header__FlexItem").addClass("Open");
 if ($(this).scrollTop()  > 160){
                $(".AnnouncementBar").slideUp(500);
              }

    }
});
});}

  */


function changeImage(image){

  var offset = 0;
  var offsetI = 0;
  offsetI = $(".Product__Slideshow .is-selected").position().top;
  offset = $("#Image"+image).position().top; 
  $(".Product__Gallery .Product__Slideshow").animate({    

    scrollTop:offset - offsetI +"px"

  }, 500); 

}



